import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=ff714c22&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff714c22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff714c22')) {
      api.createRecord('ff714c22', component.options)
    } else {
      api.reload('ff714c22', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=ff714c22&scoped=true&", function () {
      api.rerender('ff714c22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Auth/Register.vue"
export default component.exports